import * as React from "react";
const SvgFiRrPiano = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-piano_svg__a)">
      <path
        fill="#062147"
        d="M19.382 9.477a2.336 2.336 0 0 1-2.267-1.82l-.23-1.042A8.384 8.384 0 0 0 8.648 0C3.879 0 0 3.879 0 8.648V19c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5v-4.905a4.624 4.624 0 0 0-4.618-4.618M8.648 2c2.995 0 5.637 2.123 6.284 5.046l.23 1.042a4.295 4.295 0 0 0 4.22 3.389A2.62 2.62 0 0 1 22 14.095V15H2V8.648A6.655 6.655 0 0 1 8.648 2M19 22H5c-1.654 0-3-1.346-3-3v-2h3v2a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 2 0v-2h3v2c0 1.654-1.346 3-3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-piano_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPiano;
